import PropTypes from "prop-types";
import { Button } from "@wordpress/components";
import { useDispatch } from "react-redux";
import { setSelectedCollectionId } from "store/vino/productCollectionsSlice";
import { settings } from "settings";

const ViewCollectionButton = ({ collectionId }) => {
	const dispatch = useDispatch();

	const handleClick = () => {
		dispatch(setSelectedCollectionId(collectionId));
		window.location.href = settings.urls.productCollection;
	};

	return (
		<Button onClick={handleClick} className="uppercase">
			View
		</Button>
	);
};

ViewCollectionButton.propTypes = {
	collectionId: PropTypes.string.isRequired,
};

export default ViewCollectionButton;
